import Immutable from 'immutable';
import reportFromJs from 'models/reports/report_from_js';

export default {
  fromImmutable(immutable) {
    return reportFromJs(immutable.toJS());
  },

  toImmutable(entity) {
    return Immutable.fromJS(entity && entity.toJs());
  },
};



// WEBPACK FOOTER //
// ./src/scripts/adapters/immutable_converters/report_converter.js